
import React, { useContext } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import moment from 'moment'

import metadata from './MLClaimDetailsPayments.metadata.json5';
import messages from './MLClaimDetailsPayments.messages';

import { IntlContext } from '@jutro/legacy/locale';

function MLClaimDetailsPayments(props) {
    const {
        payments
    } = props;
    const translator = useTranslator();
    const intl = useContext(IntlContext)

    const formatDate = (date) => {
        return date ? moment(date).format('MM/DD/YYYY') : '';
    }

    const formatCurrency = (value) => {
        let formattedAmount = '';
        if (value) {
            const { amount, currency } = value;
            if (!_.isUndefined(amount) && currency) {
                formattedAmount = intl.formatNumber(amount, { style: 'currency', currency: currency });
            }
        }
        return formattedAmount;
    };

    const getTotalPaymentsAmount = () => {
        const total = {amount: 0, currency: 'usd'};
        payments.forEach((payment) => {
            total.amount += payment?.amountPaid?.amount || 0;
        })
        return total;
    };

    const getPaymentsTable = () => {
        if(payments.length ===  0){
            return '';
        }
        return(
            <div>
                <table className="table table-striped border-top-none vertical-spacing-30">
                    <thead>
                        <tr>
                            <th>{translator(messages.Date)}</th>
                            <th>{translator(messages.CoverageType)}</th>
                            <th>{translator(messages.AmountPaid)}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments.map((payment) => 
                            <>
                                <tr>
                                    <td className="table-data-collapse">{formatDate(payment.date)}</td>
                                    <td>{payment.coverageName_ML}</td>
                                    <td className="table-data-collapse"><strong>{formatCurrency(payment.amountPaid)}</strong></td>
                                </tr>
                                <tr className="table-section-subheader">
                                    <td />
                                    <td className="text-align-right"><strong>{translator(messages.Total)} </strong></td>
                                    <td><strong>{formatCurrency(getTotalPaymentsAmount())}</strong></td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </div>
        )
    }

    const overrides = {
        PaymentsComponent: {
            className: payments.length === 0 ? 'vertical-spacing-20' : ''
        },
        noPaymentsText: {
            visible: payments.length === 0
        },
        paymentsTable: {
            visible: payments.length > 0,
            content: getPaymentsTable()
        },
        endingHr: {
            visible: payments.length === 0
        }
    };
    const resolvers = {
        resolveClassNameMap: {},
        resolveComponentMap: {
        },
        resolveCallbackMap: {
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

export default MLClaimDetailsPayments;
